import { ChevronRight, Close, Search } from '@mui/icons-material';
import { useState } from 'react';
import Dropdown from '../Dropdown/Dropdown';
import { RadioFilter, RangeFilter } from '../ObjectBrowser';
import Range from '../Range/Range';
import './TopBar.css';

function TopBar(
    {searchValue, setSearchValue, searchPlaceholder, filters, filterValues, setFilterValues} :
    {searchValue:string, setSearchValue:any, searchPlaceholder: string, filters: Array<RadioFilter|RangeFilter|string>, filterValues: Array<string|Array<number>|null>, setFilterValues: any}
)
{
    const [isExpanded, setIsExpanded] = useState(false);
    const handleFilterChange = (index:number, newValue:any) => {
        filterValues[index] = newValue;
        setFilterValues([...filterValues]);
    }

    return (
        <div className="topBar">
            <div className="searchBar">
                <Search />
                <input type="text" value={searchValue} onChange={(e) => setSearchValue(e.target.value.toLowerCase())} placeholder={searchPlaceholder} />
                <Close style={{cursor: 'pointer', display: searchValue.length ? 'block' : 'none'}} onClick={() => setSearchValue('')} />
            </div>
            <div className={"filters" + (filters.length < 3 ? " noMobile" : "") + (isExpanded ? " mobileExpanded" : "")}>
                {(filters.length >= 3) && <div className="expander" onClick={() => setIsExpanded(!isExpanded)} />}
                {filters.map((filter, index) => {
                    if (typeof filter === 'string') {
                        return <div key={filter} className="filter">{filter}</div>;
                    }
                    switch(filter.type) {
                        case 'radio':
                            return (
                                <Dropdown
                                    dropdownValue={null}
                                    setDropdownValue={(value:any) => handleFilterChange(index, value)}
                                    key={index}
                                    options={filter.options as any}
                                    placeholder={filter.name}
                                />
                            )
                        case 'range':
                            return (
                                <Range
                                    setRangeValue={(value:any) => handleFilterChange(index, value)}
                                    key={index}
                                    min={filter.min}
                                    max={filter.max}
                                    step={filter.step}
                                    placeholder={filter.name}
                                />
                            )
                    }
                })}
                <div className="btn expandBtn" onClick={() => setIsExpanded(!isExpanded)}>
                    <ChevronRight />
                </div>
            </div>
        </div>
        )
}

export default TopBar;